import { User } from 'app/interfaces';

export type MenuItem = {
    name: string;
    path?: string;
    icon?: string;
    visible?: boolean;
    noticeCount?: number;
    children?: MenuItem[];
};

function getPrivateBasePath(): string {
    return '/me/';
}

export function getUserMenuPrimary(user: User): MenuItem[] {
    if (!user) {
        return [];
    }

    const basePath = getPrivateBasePath();

    const menu: MenuItem[] = [
        {
            name: 'profile.user.menu.home',
            path: basePath + 'home',
            icon: 'home',
        },
        {
            name: 'profile.user.menu.tickets',
            path: basePath + 'tickets',
            noticeCount: user.expiringTicketCount,
        },
        {
            name: 'profile.user.menu.discounts',
            path: basePath + 'discounts',
        },
        {
            name: 'profile.user.menu.events',
            path: basePath + 'events',
        },
        {
            name: 'profile.user.menu.receipts',
            path: basePath + 'receipts',
            visible: user.canSubmitReceipt || user.hasReceipts,
            noticeCount: user.changesRequestedReceiptCount,
        },
        {
            name: 'profile.user.menu.transactions',
            path: basePath + 'transactions',
        },
        {
            name: 'profile.user.menu.contracts',
            path: basePath + 'contracts',
            visible: user.hasRepeatingPurchaseContract,
        },
        {
            name: 'profile.user.menu.settings',
            children: [
                {
                    name: 'profile.user.menu.edit_profile',
                    path: basePath + 'settings',
                },
                {
                    name: 'profile.user.menu.payments',
                    path: basePath + 'payments',
                },
                {
                    name: 'profile.user.menu.account_security',
                    path: basePath + 'security',
                },
                {
                    name: 'profile.user.menu.notifications',
                    path: basePath + 'notifications',
                },
                {
                    name: 'profile.user.menu.language_settings',
                    path: basePath + 'language_settings',
                },
            ],
        },
    ];

    return menu.filter((item) => item.visible !== false);
}
